const TOKEN_KEY = "authToken";
const LOGIN_DATE_KEY = "loginDate";

const getTodayDate = (): string => {
  return new Date().toISOString().slice(0, 10);
};

export const setAuthToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(LOGIN_DATE_KEY, getTodayDate());
};

export const getAuthToken = (): string => {
  const token = localStorage.getItem(TOKEN_KEY);
  const loginDate = localStorage.getItem(LOGIN_DATE_KEY);
  const today = getTodayDate();

  if (!token || !loginDate || loginDate !== today) {
    clearAuthToken();
    throw new Error("Token expired or not found. Please login again.");
  }

  return token;
};

export const clearAuthToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(LOGIN_DATE_KEY);
};
